'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ../~/promise/index.js
// module id = 830
// module chunks = 17